var _ = require('underscore');
var $ = require('jquery');
var Azure = EY.Consultation.Lookups.Azure;
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var StatusType = EY.Consultation.Lookups.StatusType;

var update = function (upn, roles, geography) {
    var records = new Entities.Records();
    var filter = _.extend({ approval: '', upn: upn, approverGroupId: { $regex: roles } }, geography);
    records.fetch({ filter: { statusTypeId: { $nin: [StatusType.Complete, StatusType.UsersNotified]}, approvers: { $elemMatch: filter } } }).done(function () {
        records.each(function (record) {
            var api = Lookups.RedBoxCountryApi[record.get('countryId')];

            if (api) {
                record.urlRoot = api + 'Record';
            }
            if (record.get('assignedTo') === upn) {
                record.set('assignedTo', '');
                record.set('assignedToGivenName', '');
            }
            _.chain(record.get('approvers')).filter({ upn: upn, approval: '' }).each(function (approver) {
                approver.displayName = '';
                approver.givenName = '';
                approver.email = '';
                approver.upn = '';
                approver.rank = '';
            }).value();
            record.save({}, { validate: false });
        });
    });
};

var GraphUsers = Backbone.Collection.extend({
    model: Entities.User,
    comparator: 'displayName',
    parse: function (response) {
        return response.value;
    },
    sync: function () {
        return Backbone.sync.apply(this, arguments);
    }
});

module.exports.run = function (options) {
    var collection = new GraphUsers();
    var deferred = $.Deferred();
    var promise = deferred.promise();
    var adPromises = [];
    var deactiveUserPromises = [];
    var userDetails = 'displayName,active,adStatus,givenName,email,mail,userPrincipalName,mailNickname,surname,accountEnabled';
    $('html,body').addClass('wait-cursor');
    options.users.slice().forEach(function (user) {
        collection.url = encodeURI(Azure.GraphUrl + "users?$select=" + userDetails + "&$filter=mail eq '" + user.get("email").replace(/'/g, "''")+"'");
        var adPromise = collection.fetch().done(function () {
            var inactiveUser = collection.findWhere(function (graph) {
                return graph.get("mail").toLowerCase() === user.get("email").toLowerCase() && !graph.get("accountEnabled");
            });
            if (inactiveUser || !collection.any()) {
                deactiveUserPromises.push(user.save({
                    active:false,
                    adStatus:false,
                    roles: [],
                    geography: _.chain(user.get('roles')).pluck('geographyId').uniq().value().join('|')
                }).fail(function(){
                    $('html,body').removeClass('wait-cursor');
                }));
                update(user.get('upn'), _.pluck(_.reject(Resources.ApproverGroup, { roleId: '' }), 'id').join('|'));
            }
        }).fail(function(){
            $('html,body').removeClass('wait-cursor');
        });
        adPromises.push(adPromise);
    });
    $.when.apply(this, adPromises).done(function () {
        $.when.apply(this, deactiveUserPromises).done(function () {
            $('html,body').removeClass('wait-cursor');
            deferred.resolve();
        });
    });
    return promise;
};


// WEBPACK FOOTER //
// ./js/Modules/Service/DeactivateUsers.js